import { createFeatureSelector, createSelector } from '@ngrx/store';

import { deviceFeatureKey, State } from '../reducers/device.reducer';

export const selectDeviceFeature = createFeatureSelector<State>(deviceFeatureKey);

export const selectId = createSelector(selectDeviceFeature, (state: State) => state.uuid);

export const selectPropertyForceDeviceData = createSelector(selectDeviceFeature, (state: State) => state.deviceData);

export const selectAppName = createSelector(selectDeviceFeature, (state: State) => state.appName);

export const selectAppVersion = createSelector(selectDeviceFeature, (state: State) => state.appVersion);

export const selectDeviceType = createSelector(selectDeviceFeature, (state: State) => state.deviceType);

export const selectDeviceDimensions = createSelector(selectDeviceFeature, (state: State) => state.deviceDimensions);

export const selectOS = createSelector(selectDeviceFeature, (state: State) => state.os);

export const selectOSVersion = createSelector(selectDeviceFeature, (state: State) => state.osVersion);

export const selectIOSVersion = createSelector(selectDeviceFeature, (state: State) => state.iOSVersion);

export const selectUUID = createSelector(selectDeviceFeature, (state: State) => state.uuid);
